export function isLoginSuccessPayload(value) {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const candidate = value;
    return (typeof candidate['accessToken'] === 'string' &&
        typeof candidate['refreshToken'] === 'string' &&
        typeof candidate['jti'] === 'string');
}
export function extractLoginMfaChallenge(result, fallbackUserId) {
    if (!result || typeof result !== 'object') {
        return null;
    }
    const candidate = result;
    const getString = (key) => {
        const value = candidate[key];
        return typeof value === 'string' ? value : undefined;
    };
    const challengeId = getString('challengeId') ?? getString('sessionId') ?? getString('mfaChallengeId');
    const requiresMfa = ('mfaRequired' in candidate && Boolean(candidate['mfaRequired'])) || typeof challengeId === 'string';
    if (!requiresMfa || !challengeId) {
        return null;
    }
    const userFromRoot = getString('userId');
    const userFromNested = typeof candidate['user'] === 'object' && candidate['user'] !== null
        ? (() => {
            const nested = candidate['user'];
            if (typeof nested['userId'] === 'string')
                return nested['userId'];
            if (typeof nested['id'] === 'string')
                return nested['id'];
            return undefined;
        })()
        : undefined;
    const deliveryMethod = getString('deliveryMethod') ?? getString('method');
    const deliveryHint = getString('destination') ??
        getString('maskedDestination') ??
        getString('phone') ??
        getString('email');
    return {
        challengeId,
        userId: userFromRoot ?? userFromNested ?? fallbackUserId ?? null,
        deliveryMethod,
        deliveryHint,
    };
}
export function formatMfaChallengeHint(challenge) {
    if (!challenge) {
        return null;
    }
    const { deliveryMethod, deliveryHint } = challenge;
    if (deliveryMethod === 'sms' && deliveryHint) {
        return `Text message to ${deliveryHint}`;
    }
    if (deliveryMethod === 'email' && deliveryHint) {
        return `Email sent to ${deliveryHint}`;
    }
    if (deliveryHint) {
        return `Sent to ${deliveryHint}`;
    }
    if (deliveryMethod === 'totp') {
        return 'Check your authenticator app for the 6-digit code.';
    }
    return null;
}
export function parseLoginError(error) {
    const messages = [];
    const seen = new Set();
    const addMessage = (value) => {
        if (!value)
            return;
        if (Array.isArray(value)) {
            value.forEach(addMessage);
            return;
        }
        if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') {
            return;
        }
        const text = typeof value === 'string' ? value.trim() : String(value).trim();
        if (!text)
            return;
        const key = text.toLowerCase();
        if (seen.has(key))
            return;
        seen.add(key);
        messages.push(text);
    };
    if (!error) {
        return { messages };
    }
    const withResponse = error;
    const payload = withResponse.response?.data;
    const payloadMessage = payload?.message;
    const payloadHasMessage = Array.isArray(payloadMessage)
        ? payloadMessage.some((item) => typeof item === 'string' && item.trim())
        : typeof payloadMessage === 'string' && Boolean(payloadMessage.trim());
    if (payload) {
        addMessage(payloadMessage);
        addMessage(payload.detail);
        if (!payloadHasMessage) {
            addMessage(payload.error);
        }
    }
    if (messages.length === 0 && error instanceof Error && error.message) {
        addMessage(error.message);
    }
    const statusFromPayload = typeof payload?.statusCode === 'number' ? payload.statusCode : undefined;
    const statusFromResponse = typeof withResponse.response?.status === 'number' ? withResponse.response.status : undefined;
    return {
        messages,
        statusCode: statusFromPayload ?? statusFromResponse,
    };
}
//# sourceMappingURL=loginResult.js.map